import css from 'styled-jsx/css';

const styles = css.global`.article-review .review-btns {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}

.article-review .review-btns button {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 34px;
  width: 34px;
  padding: 0;
  margin: 0;
  background-color: transparent;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: 0.5s ease;
}

.article-review .review-btns button:first-child {
  margin-left: 0;
}

.article-review .review-btns button {
  margin-left: 16px;
}

.article-review h2 {
  max-width: 288px;
  color: #222222;
  font-family: 'SantanderHeadline';
  font-size: 18px;
  letter-spacing: 0;
  line-height: 24px;
  text-align: center;
  text-align: left;
  margin: 0 0 24px 0;
  font-weight: 500;
}

#review-btn-dislike.pressed {
  background-color: #c00;
}

#review-btn-like.pressed {
  background-color: #739e41;
}

@media (min-width: 992px) {
  .article-review h2 {
    max-width: 691px;
    color: #222222;
    font-family: 'SantanderHeadline';
    font-size: 24px;
    letter-spacing: 0;
    line-height: 36px;
  }
}
`;

export default styles;